import { PLinkPure } from "@porsche-design-system/components-react"
import type { CampaignsView } from "@slfinrtl/ui-bff-routes"
import { defineMessages, FormattedMessage, useIntl } from "react-intl"
import { useDealerAppRoutes } from "src/common/routes/useDealerAppRoutes"
import { Stage } from "src/components"
import { CampaignList } from "./CampaignsList"
import { UnknownCampaignsWarning } from "./UnknownCampaignsWarning"

const messages = defineMessages({
	pcssLink: {
		defaultMessage: "PCSS",
		id: "vehicleDetails.overview.campaigns.pcssLink",
	},
	title: {
		defaultMessage: "Open campaigns",
		id: "vehicleDetails.overview.campaigns.title",
	},
})

export interface OverviewCampaignsProps {
	view: CampaignsView
}

export const OverviewCampaigns = ({ view }: OverviewCampaignsProps) => {
	const { formatMessage } = useIntl()
	const routes = useDealerAppRoutes()

	return (
		<Stage
			actionButtons={
				routes?.external && (
					<PLinkPure
						href={routes.external.pcss.url(view.vin)}
						icon="external"
						alignLabel="start"
						target="_blank"
					>
						<FormattedMessage {...messages.pcssLink} />
					</PLinkPure>
				)
			}
			title={formatMessage(messages.title)}
		>
			{view.campaigns.length ? (
				<CampaignList campaigns={view.campaigns} />
			) : (
				<UnknownCampaignsWarning error={view.error} />
			)}
		</Stage>
	)
}
